<template>
  <action-dispatcher action="product/get" :parameters="{}" class="view-home">
    <div class="container-xxl">
      <div v-if="!products.length" class="centralize-row text-center pt-9">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <img
              class="d-block mb-9 mx-auto"
              src="../assets/images/home/welcome.png"
            />
            <h5>Bem-vindo(a) {{ userInfo.name }}</h5>
            <!-- <div class="text-secondary mb-9">
              Comece cadastrando o seu primeiro produto:
            </div>

            <big-buttons
              class="pb-6"
              :options="[
                {
                  id: 'online-course',
                  name: 'Curso online',
                  src: require(`@/assets/images/new-product/curso-online.svg`)
                },
                {
                  id: 'signature',
                  name: 'Assinatura',
                  src: require(`@/assets/images/new-product/assinatura.svg`)
                },
                {
                  id: 'event',
                  name: 'Evento presencial',
                  src: require(`@/assets/images/new-product/ticket.svg`)
                }
              ]"
              @input="open"
            /> -->
          </div>
        </div>
      </div>

      <template v-else>
        <div class="d-flex align-items-start">
          <h1 class="page-title">
            {{ greeting }}, {{ userInfo.name }}
            <small class="text-capitalize">
              {{ today }}
            </small>
          </h1>
          <div class="flex-fill"></div>
          <button
            v-if="$permissions.hasPermission('visualizar-valores')"
            class="btn btn-eye"
            @click="hideValues = !hideValues"
          >
            <i
              class="fa-regular fa-fw mr-lg-3"
              :class="{ 'fa-eye': hideValues, 'fa-eye-slash': !hideValues }"
            ></i>
            <span>{{ hideValues ? "Mostrar" : "Ocultar" }} valores</span>
          </button>
        </div>

        <div
          v-if="
            $permissions.hasPermission('gerenciar-participantes') &&
              products.length &&
              products.filter(
                p => p.type_product === 'onsite_event' && p.status === 'active'
              ).length
          "
        >
          <overview-card useSlot class="mb-6">
            <h6 class="mb-6">Check-in de participantes</h6>
            <div class="d-flex flex-column flex-lg-row align-items-lg-center">
              <div
                class="d-flex align-items-start align-items-lg-center py-3 py-lg-0 text-neutral-500"
              >
                <i class="fa-regular fa-qrcode fs-28 mx-lg-2 pt-2"></i>
                <div class="px-3 pb-4 pb-lg-0">
                  <span>
                    Faça o check-in dos seus participantes através da leitura do
                    QR Code
                  </span>
                </div>
              </div>
              <bp-button
                class="ml-lg-auto"
                label="Fazer check-in"
                size="xl"
                trailingIcon="fa-regular fa-arrow-right"
                @click="modalCheckin = true"
              />
            </div>
          </overview-card>
        </div>

        <div
          v-if="$permissions.hasPermission('visualizar-valores')"
          class="row"
        >
          <div class="col-lg-6 mb-6">
            <overview-card
              title="Minha conta"
              :hideValues="hideValues"
              :options="[
                {
                  name: 'Ganhos (últimos 7 dias)',
                  value: `R$ ${formatMoney(this.weekRevenue)}`,
                  class: 'text-dark',
                  blur: true
                },
                {
                  name: 'Saldo disponível',
                  value:
                    balance && balance.length
                      ? `${formatCurrencySymbol(
                          balance[0].currency
                        )} ${formatMoney(balance[0].amount)}`
                      : '-',
                  // secondaryValue: '-',
                  class: 'text-positive-600',
                  blur: true
                },
                {
                  name: 'A liberar',
                  value:
                    balance && balance.length && balance[0].future
                      ? `${formatCurrencySymbol(
                          balance[0].currency
                        )} ${formatMoney(
                          balance[0].future.total - balance[0].amount
                        )}`
                      : '-',
                  class: 'text-dark',
                  blur: true
                }
              ]"
            />
          </div>

          <div class="col-lg-6">
            <div
              v-if="
                products.length &&
                  products.filter(p => p.status === 'draft').length
              "
              class="mb-6"
            >
              <div class="overview-card scroll-padding">
                <div class="d-flex align-items-center">
                  <bp-icon
                    icon="fa-light fa-circle-exclamation"
                    class="text-primary-700"
                    :size="20"
                  ></bp-icon>
                  <span class="text-primary-700 fs-16">
                    Produtos que precisam de atenção
                  </span>
                  <router-link
                    v-if="products.filter(p => p.status === 'draft').length > 2"
                    class="text-dark text-decoration-none small font-weight-bold ml-auto d-none d-md-flex"
                    :to="{ name: 'product' }"
                  >
                    Ver mais
                  </router-link>
                </div>
                <div class="product-list-carousel">
                  <draft-product
                    v-for="(product, index) in products
                      .filter(p => p.status === 'draft')
                      .slice(0, 6)"
                    :key="`draft-product-${index}`"
                    :product="product"
                  />
                </div>
                <bp-button
                  class="d-md-none w-100 my-3"
                  variant="outlined"
                  color="neutral"
                  label="Ver mais"
                  size="sm"
                  route="product"
                ></bp-button>
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="overview-card">
              <sale-chart
                class="mb-6"
                :externalLoading="salesLoading"
                @change-product="onChangeProduct"
                @change-dates="onChangeDates"
              />
              <div class="row">
                <div
                  v-for="(item, index) in cardInfos"
                  :key="index"
                  :class="`col-lg-${12 / cardInfos.length} py-3 py-lg-0`"
                >
                  <overview-card
                    :title="item.title"
                    :options="item.options"
                    :externalLoading="salesLoading"
                    :hideValues="hideValues"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-3">
          <div>
            <h6 class="mb-5">Próximas conquistas</h6>
            <action-dispatcher action="user/getAchievements">
              <div
                v-for="(it, i) in achievements.slice(0, 3)"
                :key="`badge-${i}`"
                class="mb-3"
              >
                <achievement :item="it" />
              </div>
            </action-dispatcher>
          </div>
        </div> -->
        </div>
        <!-- <div class="row">
        <div class="col-lg-9">
          <h5 class="mb-5">Previsão de recebimento</h5>
          <predict-receive-table :columns="predictInfo.columns" :data="[]" />
        </div>
      </div> -->
        <responsive-modal v-model="modalCheckin">
          <event-checkin-modal
            @success="onCheckinSuccess"
            @repeated-code="onRepeatedCode"
            @close="modalCheckin = false"
          />
        </responsive-modal>
        <bp-dialog
          v-model="dialog.value"
          v-bind="dialogOptions"
          @action="onDialogAction"
        />
      </template>

      <full-screen-loading
        :visible="fullScreenLoading"
        text="Estamos montando a sua Dashboard, por favor aguarde"
      />
    </div>
  </action-dispatcher>
</template>

<script>
// import PredictReceiveTable from "@/components/home/PredictReceiveTable.vue";
// import Achievement from "@/components/achievements/Achievement.vue";
import OverviewCard from "@/components/home/card/Overview.vue";
import DraftProduct from "@/components/home/DraftProduct.vue";
import SaleChart from "@/components/home/SaleChart.vue";
import {
  formatMoney,
  getCurrencySymbol
  // clearObject
} from "@/functions/helpers";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import EventCheckinModal from "../components/events/EventCheckinModal.vue";

export default {
  components: {
    SaleChart,
    // Achievement,
    DraftProduct,
    OverviewCard,
    EventCheckinModal
    // PredictReceiveTable,
  },
  data() {
    const date = new Date();
    date.setHours(12, 0, 0, 0);
    const paid_at__lte = date.toISOString().slice(0, 10);
    date.setDate(date.getDate() - 6);
    const paid_at__gte = date.toISOString().slice(0, 10);

    return {
      hideValues: true,
      cancelTokenSource: axios.CancelToken.source(),
      dates: {
        paid_at__gte,
        paid_at__lte
      },
      weekRevenue: 0,
      totalRevenue: 0,
      saleCount: 0,
      reversalCount: 0,
      paidBillet: 0,
      product_id: "",
      salesLoading: false,
      selected: "",
      test: "",
      predictInfo: {
        columns: ["Data", "Produto", "Valor"]
      },
      activeNames: ["1"],
      modalCheckin: false,
      dialog: {
        variant: "positive",
        value: false
      }
    };
  },
  computed: {
    ...mapState("user", ["fullScreenLoading", "achievements"]),
    ...mapState("sale", ["sales"]),
    ...mapState("product", ["products"]),
    ...mapState("financial", ["balance"]),
    today() {
      return moment().format("dddd, D [de] MMMM [de] YYYY");
    },
    greeting() {
      const hour = new Date().getHours();
      if (hour < 12 && hour >= 4) return "Bom dia";
      if (hour < 18) return "Boa tarde";
      return "Boa noite";
    },
    _dates() {
      const date = new Date(this.dates.paid_at__lte);
      date.setDate(date.getDate() + 1);
      const paid_at__lte = date.toISOString().slice(0, 10);
      return {
        ...this.dates,
        paid_at__lte
      };
    },
    userInfo() {
      if (!this.$user.user)
        return {
          name: "",
          picture: "",
          last_badge: ""
        };

      return this.$user.user;
    },
    reversalPercentage() {
      return this.reversalCount
        ? this.saleCount
          ? ((this.reversalCount / this.saleCount) * 100).toFixed(2)
          : 100
        : 0;
    },
    cardInfos() {
      return [
        {
          title: "Performance",
          options: [
            {
              name: "Vendas",
              value: this.saleCount,
              class: "text-dark",
              blur: true
            }
          ]
        },
        {
          title: "Receitas",
          options: [
            {
              name: "Total",
              value: `R$ ${formatMoney(this.totalRevenue)}`,
              class: "text-positive-600",
              blur: true
            },
            {
              name: "Reembolsos",
              value: this.reversalCount,
              class: "text-negative-600",
              blur: true
            },
            {
              name: "Reembolso (%)",
              value: `${this.reversalPercentage}%`,
              class: "text-dark",
              blur: true
            }
          ]
        },
        {
          title: "Boletos",
          options: [
            // {
            //   name: "Gerados",
            //   value: "-",
            //   class: "text-dark",
            //   blur: true
            // },
            {
              name: "Pagos",
              value: this.paidBillet,
              class: "text-dark",
              blur: true
            }
            // {
            //   name: "Conversão (%)",
            //   value: "-",
            //   class: "text-dark",
            //   blur: true
            // }
          ]
        }
      ];
    },
    dialogOptions() {
      const variant = this.dialog.variant;
      return {
        variant,
        text:
          variant == "positive"
            ? "Check-in realizado com sucesso!"
            : "Esse código já foi utilizado.",
        buttonText: this.dialog.is_manual
          ? "Ok, entendi"
          : "Fazer novo check-in",
        icon:
          variant == "positive"
            ? "fa fa-circle-check"
            : "fa fa-circle-exclamation"
      };
    }
  },
  filters: {
    formatDate(dt) {
      return moment(dt).format("DD/MM/YYYY");
    }
  },
  methods: {
    open(type_product) {
      this.$router.push({ name: `product-new-${type_product}` });
    },
    async dispatch() {
      try {
        this.salesLoading = true;
        let params = {
          ...this._dates,
          product_id: this.product_id,
          status:
            "reversal,reversal_manual,reversal_manual_admin,webhook_reversal,chargeback",
          limit: 100000
        };
        this.$store
          .dispatch("sale/getCount", params)
          .then(r => (this.reversalCount = r));

        await this.$store
          .dispatch("reports/get", {
            start: params.paid_at__gte,
            end: moment().format("YYYY-MM-DD")
          })
          .then(r => {
            this.saleCount = r.reduce((prev, cur) => prev + cur.qty, 0);
          });

        params.status = "paid,completed";
        params.payment_process = "billet";
        this.$store
          .dispatch("sale/getCount", params)
          .then(r => (this.paidBillet = r));

        let totalParams = {
          product_id: this.product_id,
          status__in: ["paid", "completed"],
          ...this._dates
        };
        await this.$store
          .dispatch("sale/getTotal", totalParams)
          .then(r => (this.totalRevenue = r));
      } finally {
        this.salesLoading = false;
      }
    },
    onChangeProduct(product_id) {
      this.product_id = product_id === "all" ? "" : product_id;
      this.dispatch();
    },
    onChangeDates(dates) {
      this.dates = {
        paid_at__gte: dates[0],
        paid_at__lte: dates[1]
      };
      this.dispatch();
    },
    formatCurrencySymbol(val) {
      return getCurrencySymbol(val);
    },
    formatMoney(val) {
      return formatMoney(val);
    },
    onCheckinSuccess() {
      this.modalCheckin = false;
      this.dialog.variant = "positive";
      this.dialog.value = true;
    },
    onRepeatedCode() {
      this.modalCheckin = false;
      this.dialog.variant = "alert";
      this.dialog.value = true;
    },
    onDialogAction() {
      this.modalCheckin = true;
    }
  },
  mounted() {
    this.$store.commit("sale/setFilterDates", Object.values(this.dates));

    const filters = {
      status__in: ["paid", "completed"],
      paid_at__gte: moment()
        .subtract(6, "days")
        .format("YYYY-MM-DD"),
      paid_at__lte: moment().format("YYYY-MM-DD")
    };
    this.$store
      .dispatch("sale/getTotal", filters)
      .then(r => (this.weekRevenue = r));

    this.$store.dispatch("financial/getBalance");
    this.dispatch();
    const textAppear = localStorage.getItem("fullScreenLoading");
    const appear = textAppear ? JSON.parse(textAppear) : { visible: true };
    if (appear.visible) {
      localStorage.setItem(
        "fullScreenLoading",
        JSON.stringify({ visible: true })
      );
      this.$store.commit("user/setFullScreenLoading", true);
      setTimeout(() => {
        this.$store.commit("user/setFullScreenLoading", false);
        localStorage.setItem(
          "fullScreenLoading",
          JSON.stringify({ visible: false })
        );
      }, 4000);
    }
  }
};
</script>

<style lang="scss" scoped>
.view-home {
  position: relative;
  .centralize {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn-eye {
    color: #3d3d3d;

    @media screen and (min-width: 992px) {
      padding: 0px;
    }

    @media screen and (max-width: 991px) {
      padding: 6px 12px;
      border-radius: 4px;
      border: 1px solid #a9a9a9;

      span {
        display: none;
      }
    }
  }
  .product-list-carousel {
    display: flex;
    overflow-x: scroll;
    padding: 0px 20px;
    margin-left: -20px;
    margin-right: -20px;
    gap: 12px;

    &::-webkit-scrollbar {
      background-color: unset;
      border-radius: 0 4px 4px 0;
      height: 5.3px;
      @media screen and (max-width: 991px) {
        height: 0;
      }
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(219, 221, 230, 0.85);
      border-radius: 10px;
      border-left: 25px solid white;
      border-right: 25px solid white;
    }
  }
  .scroll-padding {
    padding-bottom: 12px !important;
    padding-top: 12px !important;
  }
}
</style>
